const namespaced = true

const state = {
  denominationsForCurrency: []
}

const mutations = {
  setDenominationsForCurrency (state, data) {
    state.denominationsForCurrency = data.denominationsForCurrency
  }
}

const getters = {
  getDenominationsForCurrency: (state) => {
    return state
  }
}

export default {
  namespaced,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/general/denominationForCurrency.js